import { apiService } from '../../shared/services/apiService';
import {
  CoachSeats,
  CoachSeatsFormValues,
  GeneralSetupInfo,
} from '../interfaces/coachSeats';
import {
  FeeTermsInfo,
  FeeTermsFormValues,
  UpdatedFeeTerms,
} from '../interfaces/feeTerms';

type GetUpgradePlanUrlResponse = {
  upgradePlanUrl: string;
};

export const entityGeneralSetupService = {
  async getCoachSeats(entityId: number | string) {
    const response = await apiService.get<CoachSeats>(
      `api/entity/${entityId}/general-setup/coach-seats/available-seats`,
    );

    return response.data;
  },

  async createCoachSeats(entityId: number | string, coachSeats: CoachSeatsFormValues) {
    const response = await apiService.post<GeneralSetupInfo>(
      `/api/entity/${entityId}/general-setup/coach-seats`,
      coachSeats,
    );

    return response.data;
  },

  async updateCoachSeats(entityId: number | string, coachSeats: CoachSeatsFormValues) {
    const response = await apiService.put<GeneralSetupInfo>(
      `/api/entity/${entityId}/general-setup/coach-seats`,
      coachSeats,
    );

    return response.data;
  },

  async getUpgradePlanUrl(entityId: number, isRunGlobalSpinner: boolean = false) {
    const resp = await apiService.get<GetUpgradePlanUrlResponse>(
      `/api/entity/${entityId}/general-setup/coach-seats/upgrade-plan`,
      { isRunGlobalSpinner },
    );

    return resp.data;
  },
  // update
  async getFeeTerms(entityId: number) {
    const resp = await apiService.get<FeeTermsInfo>(
      `/api/entity/${entityId}/general-setup/fee-terms`,
    );

    return resp.data;
  },

  async createFeeTerms(entityId: number, feeTerms: FeeTermsFormValues) {
    const resp = await apiService.post<UpdatedFeeTerms>(
      `/api/entity/${entityId}/general-setup/fee-terms`,
      feeTerms,
    );

    return resp.data;
  },

  async updateFeeTerms(entityId: number, feeTerms: FeeTermsFormValues) {
    const resp = await apiService.put<UpdatedFeeTerms>(
      `/api/entity/${entityId}/general-setup/fee-terms`,
      feeTerms,
    );

    return resp.data;
  },
};
